import React  from "react";
import { useParams } from 'react-router-dom';
import PayrollForm from "./components/PayrollForm";

const ViewPayroll = () => {

	const { payrollId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<PayrollForm recordId={payrollId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default ViewPayroll;